import { Component, Inject, OnInit } from "@angular/core";
import { FormService } from "../../../core/services/v2/form.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { EditorChangeContent, EditorChangeSelection } from "ngx-quill";
import Quill from "quill";
import { ImageResize } from "quill-image-resize-module";
import ImageCompress from "quill-image-compress";
import { DynamicFormHeader } from "src/app/core/models/physician/dynamicFormHeader";
var style = Quill.import("attributors/style/align");

Quill.register(style, true);
Quill.register("modules/imageCompress", ImageCompress);
Quill.register("modules/imageResize", ImageResize);

@Component({
  selector: "app-design-header",
  templateUrl: "./design-header.component.html",
  styleUrls: ["./design-header.component.scss"],
})
export class DesignHeaderComponent implements OnInit {
  editorText = "";
  htmlPreview: any;

  options: any = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // toggled buttons
      ["blockquote"],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }], // superscript/subscript
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],

      ["clean"], // remove formatting button

      ["link", "image", "url"], // link and image, video
    ],
    imageResize: {
      displaySize: true,
    },
    imageCompress: {
      maxWidth: 600,
      maxHeight: 180,
      imageType: ["image/jpeg", "image/png"],
      debug: true,
    },
  };
  content = "";
  quillEditor: any;

  constructor(
    private formService: FormService,
    private loaderService: WindowLoaderService
  ) {}

  ngOnInit() {
    this.getHTMLPreview();
  }

  created(editor) {
    const range = editor.getSelection(true);
  }

  getHTMLPreview() {
    this.formService.getHTMLPreview().subscribe((res) => {
      this.editorText = res.result.header;
    });
  }

  saveHtmlPreview() {
    this.loaderService.show();
    let dynamicFormHeader = new DynamicFormHeader();
    dynamicFormHeader.header = this.editorText;
    this.formService
      .saveHeaderDesignHtml(dynamicFormHeader)
      .subscribe((res) => {
        console.log(res);
        this.loaderService.hide();
      });
  }
}
